
export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div className="absolute inset-0 z-0">
        <div className="w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/86619c456844ea3632db3f4d63bfb6c1.jpg"
            alt="El Paso vacant land for sale"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center text-white">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <i className="ri-map-pin-fill text-teal-400 text-xl"></i>
            <span className="text-sm font-medium">Serving El Paso County & Southern New Mexico</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Sell Your Land Fast for <span className="text-teal-400">Cash</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-gray-100 leading-relaxed max-w-4xl mx-auto">
            We buy land for cash in El Paso and surrounding areas. No realtor commissions, no closing costs, no waiting months for a buyer. Get your fair cash offer in 24 hours and close in as little as 7 days.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a href="tel:+1-915-206-5814" className="inline-flex items-center space-x-2 px-8 py-4 bg-teal-600 text-white rounded-lg font-bold text-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-phone-fill"></i>
              <span>(915) 206-5814</span>
            </a>
            <a href="#process" className="inline-flex items-center space-x-2 px-8 py-4 bg-white text-gray-900 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
              <span>How It Works</span>
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-2">
                <i className="ri-money-dollar-circle-fill text-teal-400 text-4xl"></i>
              </div>
              <div className="text-sm font-semibold">All Cash Offers</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-2">
                <i className="ri-time-fill text-teal-400 text-4xl"></i>
              </div>
              <div className="text-sm font-semibold">Close in 7 Days</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-2">
                <i className="ri-shield-check-fill text-teal-400 text-4xl"></i>
              </div>
              <div className="text-sm font-semibold">No Closing Costs</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-2">
                <i className="ri-checkbox-circle-fill text-teal-400 text-4xl"></i>
              </div>
              <div className="text-sm font-semibold">Sell As-Is</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
